import * as _ from 'lodash-es';
import React from 'react';
import { FormConfirmationModal } from '../../components/ConfirmationModal';
import { Field } from '../../components/Form';

const REASONS = [
  ..._.shuffle([
    'Switching to competitor',
    'Too expensive',
    'Too many issues or bugs',
    'Not enough usage',
  ] as const),
  'Other',
] as const;

type Values = {
  reason?: (typeof REASONS)[number];
  details: string;
};

interface ChurnModalProps {
  onSubmit: (values: Values) => Promise<unknown>;
  close: () => void;
}

const ChurnModal = ({ onSubmit, close }: ChurnModalProps) => (
  <FormConfirmationModal<Values>
    form={{
      onSubmit,
      initialValues: {
        reason: undefined,
        details: '',
      },
    }}
    close={close}
    title="Cancel your subscription?"
    cancelButtonText="Go back"
    description="Without an active subscription, all posts will become read-only."
    submitButton={{
      text: 'Confirm',
    }}
  >
    {({ values }) => {
      return (
        <>
          <Field
            name="reason"
            label="Reason for canceling"
            type="select"
            placeholder="Choose a reason"
            options={REASONS.map((r) => ({
              value: r,
              label: r,
            }))}
            isSearchable={false}
            required
          />
          {values.reason === 'Other' && (
            <Field
              name="details"
              label="Please describe"
              type="textarea"
              placeholder="Please provide feedback about why you are canceling. Thank you!"
              required
            />
          )}
        </>
      );
    }}
  </FormConfirmationModal>
);

export default ChurnModal;
